import { defineStore } from "pinia";
import { ref } from "vue";

export const useOrderInfoStore = defineStore("order-info", () => {
  const orderInfo = ref({
    patientPrefix: null,
    patientFirstName: null,
    patientMiddleName: null,
    patientLastName: null,
    patientSuffix: null,
    patientDob: null,
    patientMemberId: null,
    patientInsuranceMemberName: null,
    patientPhone: null,
    patientGender: null,
    patientAddress1: null,
    patientAddress2: null,
    patientCity: null,
    patientState: null,
    patientZip: null,
    patientWeight: null,
    patientHeight: null,
    patientSsn: null,
    patientDrugAllergies: null,
    providerFirstName: null,
    providerLastName: null,
    providerTitle: null,
    providerContactName: null,
    providerContactPhone: null,
    providerContactFax: null,
    providerNpiNumber: null,
    providerTin: null,
    providerSpecialty: null,
    providerOfficeName: null,
    providerOfficePhone: null,
    providerFax: null,
    providerEmail: null,
    forwardResponsesToProviderByEmail: false,
    providerAddress1: null,
    providerAddress2: null,
    providerCity: null,
    providerState: null,
    providerZip: null,
    providerDeaNumber: null,
    providerLicenseNumber: null,
    primaryDiagnosisName: null,
    primaryDiagnosisIcd10Code: null,
    secondaryDiagnosis: [
      {
        name: null,
        icd10Code: null,
      },
      {
        name: null,
        icd10Code: null,
      },
      {
        name: null,
        icd10Code: null,
      },
      {
        name: null,
        icd10Code: null,
      },
      {
        name: null,
        icd10Code: null,
      },
      {
        name: null,
        icd10Code: null,
      },
    ],
    medication: null,
    nationalDrugCode: null,
    daw: "No",
    dailyDosage: null,
    frequency: null,
    expectedLengthOfTherapy: null,
    quantityPer30Days: null,
    packageSizeUnit: null,
    treatmentStartDate: null,
    expeditedReviewStatement: null,
    expeditedReviewWithin24h: null,
    pharmacyInfo: null,
    checklist: [],
    checklistLlmScores: [],
    basicPlusChecklist: [],
    basicPlusChecklistLlmScores: [],
    diagnosisLlmScores: null,
    insuranceProvider: null,
    insurancePlanType: null,
    benefitType: null,
    medicalNecessity: [],
    patientChart: [],
    additionalPatientExternalIds: [],
    orderKey: null,
    formStep: null,
    payerQuestions: [],
    basicPlusQuestions: [],
    medicalNecessityTemplate: null,
    signature: null,
    stageOfTherapy: null,
    bin: null,
    processorControlNumber: null,
    grpNumber: null,
    faxDescription: null,
    submissionMethod: null,
    extraMedications: [],
    editableSubmissionForm: {},
    filledFormUrl: null,
    sendFaxFormTo: null,
    clientCompanyId: null,
    staffEditOverride: false,
  });

  return {
    orderInfo,
  };
});
